const bannerManageNew = () => import("./views/bannerManage.vue");

export default {
  path: "/bannerManage",
  name: "bannerManage",
  component: bannerManageNew,
  meta: {
    root: "/appCenter"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/banner/router.js